export default __webpack_public_path__ + "static/media/verify-email.2867d650.svg";